
export class GetCourseMinPriceByCourseIdsRequestDto {
  courseIds: string[];
}
